export default __webpack_public_path__ + "static/media/img2.cc5410e6.png";